<template>
  <div class="specialdet">
    <div class="w12 between">
      <lvbreadcrumb class="speltmbx" :tolist="tolist" />
      <div class="cialdetleft">
        <cialdetzw class="com" :lawinfo="lawinfo" />
        <cialdetrelans class="com mt30" :list="tjvideolist" />
      </div>
      <div class="cialdetright">
        <cialdetyxtj />
        <speltfocblem class="mt30 com" :list="gztllist" />
      </div>
    </div>
  </div>
</template>

<script>
import cialdetyxtj from "./components/cialdetyxtj";
import cialdetzw from "./child/cialdetzw";
import cialdetrelans from "./child/cialdetrelans";
import speltfocblem from "views/speciallist/components/speltfocblem";
import lvbreadcrumb from "components/content/lvbreadcrumb/lvbreadcrumb";
export default {
  components: {
    cialdetyxtj,
    cialdetzw,
    speltfocblem,
    cialdetrelans,
    lvbreadcrumb,
  },
  data: () => ({
    hidenum: 0,
    gztllist: [],
    tjvideolist: [],
    lawinId: 0,
    lawinfo: {},
  }),
  computed: {
    getfljj() {
      return this.$store.state.laws.fljjxx;
    },
    tolist() {
      return [
        {
          name: "首页",
          path: "/",
        },
        {
          name: "法律聚焦",
          path: "/laws/special",
        },
        {
          name: this.lawinfo.title || '',
        }
      ];
    },
  },
  beforeMount() {
    this.lawinId = this.$route.query.lawonId;
    this.getgztl();
    this.getvideo()
    this.getlawoninfo()
  },
  methods: {
    getgztl() {
      let data = {
        limit: 5,
        page: 1,
        order: "hot",
      };
      this.$http.laws.getarticlist(data).then((res) => {
        console.log(res.data);
        this.gztllist = res.data.data;
      });
    },
    getvideo() {
      let data = {
        limit: 6,
        page: 1,
        order: "hot",
      };
      this.$http.laws.getvideolist(data).then((res) => {
        console.log(res.data);
        this.tjvideolist = res.data.data;
      });
    },
    getlawoninfo() {
      let data = {
        id: this.lawinId,
      };
      this.$http.laws.getnewscontent(data).then((res) => {
        this.lawinfo = res.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.specialdet {
  background: #f8f8f8;
  .w12 {
    width: 1200px;
    margin: 0 auto;
    padding: 50px 0;
    align-items: flex-start;
    position: relative;
  }
  .com {
    background: #ffffff;
  }
  .cialdetleft {
    width: 855px;
  }
  .cialdetright {
    width: 315px;
  }

  .speltmbx {
    position: absolute;
    top: 20px;
    left: 0;
  }
}
</style>


